import React from 'react';

/**
 * A single KPI tile. `value` is pre-formatted by the caller so this component
 * never has to know whether it is showing a duration, a percentage or a count.
 * With `onClick` the whole tile is a button, named by `actionLabel`.
 */
const StatCard = ({ eyebrow, value, caption, tone = 'default', onClick, actionLabel }) => {
  const body = (
    <>
      {eyebrow ? <span className="td-stat__eyebrow">{eyebrow}</span> : null}
      <span className="td-stat__value">{value}</span>
      {caption ? <span className="td-stat__caption">{caption}</span> : null}
    </>
  );
  if (onClick) {
    return (
      <button type="button" className={`td-stat td-stat--${tone} td-stat--button`} onClick={onClick} aria-label={actionLabel}>
        {body}
      </button>
    );
  }
  return <div className={`td-stat td-stat--${tone}`}>{body}</div>;
};

export default StatCard;
